<template>
  <div class="">
    <div class="box add" @click="handleUploadFile">
      <div class="text-center">
        <div class="add-icon">
          <font-awesome-icon icon="plus" title="file attachment" />
        </div>
        เพิ่มไฟล์
      </div>
    </div>
    <div class="hide-upload-panel">
      <UploadFile
        textFloat="File"
        placeholder="Please Choose File"
        format=""
        name="file"
        text="*Please upload only file .xlsx less than 10 MB"
        isRequired
        v-on:onFileChange="uploadFile"
        v-on:delete="deleteFile"
        :fileName="filename"
        v-model="attachment"
        id="uploadfile"
        :v="$v.filename"
        :isValidate="$v.filename.$error"
        ref="uploadFile"
      />
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import UploadFile from "@/components/inputs/UploadFile";
export default {
  components: { UploadFile },
  validations() {
    return {
      filename: {
        required,
      },
    };
  },
  data() {
    return { isShow: false, filename: "", attachment: "" };
  },
  methods: {
    hide() {
      this.isShow = false;
    },
    show() {
      this.$v.filename.$reset();
      this.isShow = true;
      this.filename = null;
      this.attachment = null;
    },
    async submit() {
      try {
        this.$v.filename.$touch();
        if (this.$v.filename.$error) return;
        this.$bus.$emit("showLoading");
        let payload = {
          Base64String: this.attachment,
          is_video: false,
          is_file: true,
          type: 1,
          file_name: this.filename,
        };
        const result = await this.axios.post("/ticket/UploadFile", payload);
        this.$bus.$emit("hideLoading");
        this.$emit("uploadFile", {
          name: this.filename,
          path: result.data.detail,
        });
      } catch (error) {
        this.errorAlert(error.message);
        this.$bus.$emit("hideLoading");
      }
    },
    uploadFile(file) {
      this.filename = file.name;
      this.isDisable = false;

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.attachment = reader.result;
        this.submit();
      };
    },
    deleteFile() {
      this.attachment = null;
      this.filename = null;
      this.isDisable = true;
    },
    handleUploadFile() {
      this.$refs.uploadFile.$refs.input.click();
    },
  },
};
</script>

<style lang="scss">
.box {
  width: 100px;
  height: 100px;
  border-radius: 0.4rem;
  color: rgb(129, 129, 129);
  &.add {
    border: 1px dashed #999999;
    display: flex;
    align-items: center;
    justify-content: center;
    > .add-icon {
      border-radius: 50%;
      height: 24px;
      /* padding: 6px; */
      width: 24px;

      text-align: center;
    }
  }
}
.hide-upload-panel {
  visibility: hidden;
  position: absolute;
  left: -9999px;
  top: -9999px;
}
</style>
